import type { MovementTruthTerminalInfo } from '../janus-engine/movement/client-truth-commit';

export interface AppliedSaveInput {
  encounterId: string; actorIds: string[];
  command: { schema: string; operation_id: string };
  send: () => Promise<{ ok: boolean; status?: number; error?: string }>;
  refused: (info: MovementTruthTerminalInfo) => void | Promise<void>;
  /** Stop a dependent UI wait when delivery parks; the immutable save remains retryable. */
  parked?: () => void;
  confirmed?: Array<{ actorId: string; rev: number; aps?: number }>;
}

/** Stateless entry for bundles that use equipment without owning websocket state. */
export function queueAppliedSave(input: AppliedSaveInput): void {
  if (window.ftQueueActorSave) window.ftQueueActorSave(input);
  else (window.ftPendingActorSaves ??= []).push(input);
}

declare global {
  interface Window {
    ftQueueActorSave?: (input: AppliedSaveInput) => void;
    ftPendingActorSaves?: AppliedSaveInput[];
  }
}
